<template>
  <div style="padding-top: 10px">
    <span v-if="isLoadding" style="height: 100px">
      <v-container
        fill-height
        fluid
        :style="
          display === 'Desktop'
            ? 'height: ' + (heightDisplay - 325) + 'px;'
            : 'height: ' + (heightDisplay - 150) + 'px;'
        "
      >
        <v-row align="center" justify="center">
          <v-col
            lg="12"
            sm="12"
            md="12"
            cols="12"
            xl="12"
            xs="12"
            class="text-center"
            ><h1 style="font-size: 48px">
              <span style="color: #3f44a3">Kan</span>
              <span style="color: #4a98b2">Pramool</span>
            </h1>
          </v-col>
          <v-col
            class="text-center"
            sm="10"
            md="6"
            cols="8"
            xl="3"
            xs="10"
            lg="3"
            ><v-progress-linear
              color="#F8F364"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear
          ></v-col>
        </v-row>
      </v-container>
    </span>

    <v-form v-model="valid">
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title style="font-family: 'Kanit', sans-serif"
            >กรุณากรอกเลขโครงการ</v-card-title
          >
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              placeholder="เลขที่โครงการ"
              type="text"
              @change="checkprojectCode()"
              v-model.trim="form.project_code"
              :rules="rules.project_code"
              outlined
              hide-details="auto"
              dense
            ></v-text-field>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" @click="checkTor()" style="color: #fff">
              <v-icon left light style="color: #fff"
                >mdi-content-save-outline</v-icon
              >
              เพิ่มข้อมูล
            </v-btn>
            <v-btn color="red" @click="cancelScreenedit()" style="color: #fff">
              <v-icon left light style="color: #fff">mdi-close-octagon</v-icon>
              ปิดหน้าจอ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container>
        <v-dialog v-model="dialog1" persistent max-width="1000" class="theme">
          <v-card>
            <v-img src="../assets/moph.gif" height="20%" dark> </v-img>
          </v-card>
        </v-dialog>
        <v-card class="mx-auto" max-width="1000">
          <v-img src="../assets/3156482.jpg" height="150px"> </v-img>

          <v-row class="Format2">
            <v-col
              cols="12"
              sm="6"
              md="6"
              style="padding-left: 0px"
              class="Format"
            >
              <v-card-text class="Format">
                <b> วันที่เริ่มรับฟังคำวิจารณ์</b>
                <v-menu
                  ref="menu"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                </v-menu>
                <v-dialog
                  ref="dialog"
                  v-model="modal1"
                  persistent
                  width="320px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      readonly
                      placeholder="คลิกเพื่อเลือก"
                      v-model="form.tor_date_start"
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                      :rules="rules.tor_date_start"
                      outlined
                      dense
                      target="#dropdown-example-2"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.tor_date_start"
                    scrollable
                    locale="th-TH"
                    color="green lighten-1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="success"
                      @click="$refs.dialog.save(day1), (modal1 = false)"
                    >
                      ตกลง
                    </v-btn>
                    <v-btn text color="red" @click="modal1 = false"
                      >ยกเลิก</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-card-text>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              style="padding-left: 0px"
              class="Format"
            >
              <v-card-text class="Format">
                <b> วันที่สิ้นสุดรับฟังคำวิจารณ์</b>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                </v-menu>
                <v-dialog ref="dialog" v-model="modal" persistent width="320px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      readonly
                      placeholder="คลิกเพื่อเลือก"
                      v-model="form.tor_date_project"
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                      :rules="rules.tor_date_project"
                      outlined
                      dense
                      target="#dropdown-example-2"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.tor_date_project"
                    scrollable
                    locale="th-TH"
                    color="green lighten-1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="success"
                      @click="$refs.dialog.save(day), (modal = false)"
                    >
                      ตกลง
                    </v-btn>
                    <v-btn text color="red" @click="modal = false"
                      >ยกเลิก</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-card-text>
            </v-col>

            <v-col cols="12" sm="12" md="12" class="Format">
              <b>ชื่อย่อโครงการ</b>
              <v-text-field
                placeholder="ชื่อย่อโครงการ"
                type="text"
                dense
                v-model="form.short_project_name"
                :rules="rules.short_project_name"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="Format">
            <v-col cols="12" sm="12" md="12" class="Format">
              <b>ชื่อโครงการ(เรื่อง)</b>
              <v-textarea
                outlined
                name="input-4-4"
                placeholder="ชื่อโครงการ(เรื่อง)"
                v-model="form.project_name"
                :rules="rules.project_name"
                dense
                rows="3"
                row-height="25"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="Format">
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>ชื่อหน่วยงานรับผิดชอบ</b>
              <v-text-field
                dense
                placeholder="ชื่อหน่วยงานรับผิดชอบ"
                type="text"
                v-model="form.institution"
                :rules="rules.institution"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>ประเภทการจัดหา</b>
              <v-autocomplete
                v-model="form.genus_typ"
                :rules="rules.genus_typ"
                :items="genusTyp"
                item-text="genus_typ_name"
                item-value="genus_typ_id"
                outlined
                dense
                placeholder="ประเภทการจัดหา"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>ประเภทงาน</b>
              <v-autocomplete
                v-model="form.type_of_work"
                :items="typeOfWork"
                item-text="job_type_name"
                item-value="job_type_id"
                hide-details="auto"
                outlined
                dense
                chips
                small-chips
                type="text"
                placeholder="ประเภทงาน"
                multiple
                :rules="rules.type_of_work"
              >
                <template v-slot:selection="data">
                  <v-chip close small class="chip--select-multi">
                    {{ data.item.job_type_name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content
                      v-text="data.item.job_type_name"
                    ></v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="Format">
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>จังหวัด</b>
              <v-autocomplete
                v-model="form.province"
                :rules="rules.province"
                :items="provinces"
                item-text="name_th"
                item-value="id"
                @input="getamphures()"
                outlined
                dense
                placeholder="จังหวัด"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>อำเภอ</b>
              <v-autocomplete
                v-model="form.amphures"
                @input="getdistricts()"
                :rules="rules.amphures"
                :items="amphuress"
                item-text="name_th"
                item-value="id"
                outlined
                dense
                placeholder="อำเภอ"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>ตำบล</b>
              <v-autocomplete
                v-model="form.districts"
                :rules="rules.districts"
                :items="districtss"
                item-text="name_th"
                item-value="id"
                outlined
                dense
                placeholder="ตำบล"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="Format">
            <v-col cols="12" sm="6" md="6" class="Format">
              <b>งบประมาณโครงการ</b>
              <v-text-field
                @input="changeExpenditure()"
                placeholder="งบประมาณโครงการ"
                dense
                v-model="form.expenditure"
                :rules="rules.expenditure"
                outlined
              >
                <span slot="append">บาท</span></v-text-field
              >
            </v-col>
            <v-col cols="12" sm="6" md="6" class="Format">
              <b> ราคากลาง</b>
              <v-text-field
                placeholder="ราคากลาง"
                v-model="form.middle_price"
                :rules="rules.middle_price"
                outlined
                dense
                @input="changeMiddle()"
                target="#dropdown-example-2"
                ><span slot="append">บาท</span></v-text-field
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-center">
                <v-btn
                  style="width: 422px"
                  rounded
                  color="success"
                  :disabled="!valid"
                  @click="onSubmit"
                  >บันทึกข้อมูลTORเข้าสู่ระบบ</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      heightDisplay: null,
      show: false,
      menu: null,
      modal: null,
      day: null,
      menu1: null,
      modal1: null,
      day1: null,
      checkcode: false,
      dialog: false,
      isLoadding: false,
      isdata: false,
      dialog1: false,
      valid: false,
      projectStatus: [],
      genusTyp: [],
      typeOfWork: [],
      announcementType: [],
      provinces: [],
      amphuress: [],
      districtss: [],
      display: null,
      form: {
        type: "tor",
        tor_status_id: 1,
        institution: null, //ชื่อหน่วยงานรับผิดชอบ
        project_code: null, //รหัสโครงการ
        short_project_name: null,
        project_name: null, //ชื่อโครงการ
        tor_date_start: null, //วันที่เริ่มประกาศ
        tor_date_end: null, //วันที่สิ้นสุดประกาศ
        tor_date_project: null, //วันที่ประกาศ-วันที่สิ้นสุดรับฟังคำวิจารณ์
        expenditure: null, //งบประมาณโครงการ
        province: null, //จังหวัด
        amphures: null,
        districts: null,
        genus_typ: null, //ประเภทการจัดหา
        type_of_work: null, //ประเภทงาน
        middle_price: null, //ราคากลาง
        created_by: localStorage.getItem("username"), //เพิ่มโดย
        created_by_notify: localStorage.getItem("fullname"),
      },
      rules: {
        short_project_name: [
          (v) => (!!v && v.length <= 100) || "กรุณากรอกชื่อโครงการให้ถูกต้อง",
        ],
        project_code: [
          (v) => (!!v && v.length == 11) || "กรุณากรอกเลขโครงการให้ถูกต้อง",
        ],
        project_name: [
          (v) => (!!v && v.length <= 500) || "กรุณากรอกชื่อโครงการให้ถูกต้อง",
        ],
        institution: [
          (v) =>
            (!!v && v.length <= 100) ||
            "กรุณากรอกชื่อหน่วยงานรับผิดชอบให้ถูกต้อง",
        ],
        expenditure: [
          (v) =>
            (!!v &&
              parseFloat(v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) >=
                0) ||
            "กรุณากรอกงบประมาณโครงการให้ถูกต้อง",
        ],
        province: [(v) => !!v || "กรุณากรอกจังหวัดให้ถูกต้อง"],
        amphures: [(v) => !!v || "กรุณากรอกอำเภอให้ถูกต้อง"],
        districts: [(v) => !!v || "กรุณากรอกตำบลให้ถูกต้อง"],
        middle_price: [
          (v) =>
            (!!v &&
              parseFloat(v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) >=
                0) ||
            "กรุณากรอกราคากลางให้ถูกต้อง",
        ],
        genus_typ: [(v) => !!v || "กรุณากรอกวันที่ยื่นเสนอราคาให้ถูกต้อง"],
        type_of_work: [(v) => !!v || "กรุณาเลือกประเภทงานให้ถูกต้อง"],
      },
    };
  },

  mounted() {
    this.isLoadding = true;
    this.checkHightDisplay();
    if (localStorage.getItem("username") === undefined) {
      alert("กรุณาลงชื่อเข้าสู่ระบบก่อน");
      this.$router.push("/login");
    } else {
      axios.get(this.api + "/get/tor_project_status").then((res) => {
        this.projectStatus = [];
        this.projectStatus = res.data.response;
        axios.get(this.api + "/get/ebiiding_jobtype").then((res) => {
          this.typeOfWork = [];
          this.typeOfWork = res.data.response;
          axios.get(this.api + "/get/tor_genus_typ").then((res) => {
            this.genusTyp = [];
            this.genusTyp = res.data.response;
            axios.get(this.api + "/get/provinces").then((res) => {
              this.provinces = [];
              this.provinces = res.data.response;
              this.isLoadding = false;
              this.dialog = true;
            });
          });
        });
      });
    }
  },
  methods: {
    checkHightDisplay() {
      this.heightDisplay = screen.height;
    },
    getamphures() {
      if (this.form.province != null) {
        this.isLoadding = true
        axios
          .post(this.api + "/get/amphures", { province: this.form.province })
          .then((res) => {
             this.isLoadding = false
            this.amphuress = res.data.response;
          });
      } else {
        alert("กรุณาเลือกจังหวัด");
      }
    },
    getdistricts() {
      if (this.form.amphures != null) {
        this.isLoadding = true
        axios
          .post(this.api + "/get/districts", { amphure: this.form.amphures })
          .then((res) => {
            this.isLoadding = false
            this.districtss = res.data.response;
          });
      } else {
        alert("กรุณาเลือกอำเภอ");
      }
    },
    checkprojectCode() {
      if (this.form.project_code != null) {
        if (this.form.project_code.length == 11) {
          if (this.form.project_code >= 1) {
            this.checkcode = true;
          } else {
            alert("กรุณากรอกข้อมูลเฉพาะตัวเลขเท่านั้น");
            location.reload();
          }
        } else {
          alert("กรุณากรอกข้อมูลเลขที่โครงการให้ครบ 11 หลัก");
          location.reload();
        }
      } else {
        alert("กรุณาเพิ่มข้อมูลโครงการ");
        location.reload();
      }
    },
    checkTor() {
      if (this.form.project_code != null) {
        if (this.form.project_code.length == 11) {
          if (this.form.project_code >= 1) {
            // console.log("ถูกเเล้ว");
          } else {
            alert("กรุณากรอกข้อมูลเฉพาะตัวเลขเท่านั้น");
            location.reload();
          }
        } else {
          alert("กรุณากรอกข้อมูลเลขที่โครงการให้ครบ 11 หลัก");
          location.reload();
        }
      } else {
        alert("กรุณาเพิ่มข้อมูลโครงการ");
        location.reload();
      }
      this.dialog = false;
    },
    cancelScreenedit() {
      this.dialog = false;
      this.$router.push("/showdatatoradmin");
    },
    changeExpenditure() {
      this.form.expenditure = this.form.expenditure
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeMiddle() {
      this.form.middle_price = this.form.middle_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    onSubmit() {
      this.isLoadding = true;
      this.form.project_name = this.form.project_name
        .split("(เลขที่โครงการ")[0]
        .trim();
      this.form.institution = this.form.institution.trim();
      // console.log(this.form)
      axios.post(this.api + "/post/adddata", this.form).then((res) => {
        this.isLoadding = false;
        this.form.tor_id = res.data.response;
        if (res.data.status) {
          // console.log(res.data.response)
          this.$router.push("/showdatatoradmin");
        } else {
          alert(res.data.error);
        }
      });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit&display=swap");
.theme {
  background: #f1fff4;
}
.home-page {
  padding-top: 0px;
  padding-bottom: 0px;
}

.Format {
  padding-top: 0px;
  padding-left: 20px;
  padding-right: 20px;
}
.Format2 {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.inputOrderIn {
  font-size: 30px;
  font-weight: bold;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
